// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import { parseCsv, normalizeText } from './utils.js';
import { isNativeFormControl, getValueFromControl } from './controls.js';

export var _collectState = function () {
  var filtersByField = {};
  var searchGroups = [];
  var self = this;

  this.currentLogic = this._resolveCurrentLogic();

  this.filterControls.forEach(function (control) {
    var field = normalizeText(control.getAttribute('data-pf-filter'));
    if (!field) {
      return;
    }

    var values = getValueFromControl(control);
    if (!values.length) {
      return;
    }

    if (!filtersByField[field]) {
      filtersByField[field] = [];
    }

    var matchMode = normalizeText(control.getAttribute('data-pf-match') || '');
    if (!matchMode) {
      if (!isNativeFormControl(control)) {
        matchMode = 'exact';
      } else {
        var tag = control.tagName.toLowerCase();
        var type = (control.type || '').toLowerCase();
        matchMode = tag !== 'select' && type !== 'checkbox' && type !== 'radio' ? 'contains' : 'exact';
      }
    }

    values.forEach(function (value) {
      var normalized = normalizeText(value);
      if (!normalized || normalized === '*') {
        return;
      }

      filtersByField[field].push({
        raw: value,
        value: normalized,
        mode: matchMode === 'contains' ? 'contains' : 'exact',
      });
    });
  });

  this.searchControls.forEach(function (searchControl, index) {
    var searchValue = String(searchControl.value || '').trim();
    if (!searchValue) {
      return;
    }

    var fields = parseCsv(searchControl.getAttribute('data-pf-search'))
      .map(normalizeText)
      .filter(Boolean);

    if (!fields.length) {
      return;
    }

    searchGroups.push({
      id: index,
      raw: searchValue,
      query: normalizeText(searchValue),
      tokens: normalizeText(searchValue)
        .split(/\s+/)
        .filter(Boolean),
      fields: fields,
    });
  });

  return {
    logic: this.currentLogic,
    filtersByField: filtersByField,
    searchGroups: searchGroups,
    page: this.currentPage,
    urlPrefix: this._urlPrefix(),
    pageSize: self.pageSize,
  };
};

export var _resolveCurrentLogic = function () {
  if (!this.logicToggles.length) {
    return this.defaultLogic;
  }

  for (var i = 0; i < this.logicToggles.length; i += 1) {
    var control = this.logicToggles[i];
    var type = (control.type || '').toLowerCase();

    if (type === 'checkbox') {
      if (control.checked) {
        return normalizeText(control.getAttribute('data-pf-logic-on') || 'or') === 'or' ? 'or' : 'and';
      }
      return normalizeText(control.getAttribute('data-pf-logic-off') || this.defaultLogic) === 'or' ? 'or' : 'and';
    }

    if (type === 'radio') {
      if (control.checked) {
        return normalizeText(control.value || this.defaultLogic) === 'or' ? 'or' : 'and';
      }
      continue;
    }

    var value = normalizeText(control.value || this.defaultLogic);
    return value === 'or' ? 'or' : 'and';
  }

  return this.defaultLogic;
};

